const BizionarDemoMock = {
  settings: {
    client: "",
    project_id: "",
    projectName: "",
    limitDate: "",
    shots_base_url: "",
    thumbs_base_url: "",
  },
  legalSettings: {
    legalAdviceUrl: "https://metrovacesa.com/aviso-legal",
    privacyPolicyUrl: "https://metrovacesa.com/politica-privacidad",
    cookiesUrl: "https://metrovacesa.com/politica-de-cookies",
    legalNote: "Imágenes no contractuales y meramente ilustrativas. Por ello, en caso de contradicción entre las imágenes aquí reflejadas con la información recogida en los documentos contractuales entregados al cliente, prevalecerán siempre éstos últimos. El mobiliario mostrado no está incluido, siendo el equipamiento del inmueble el indicado en la memoria de calidades.",
  },
  rooms: [
    {
      id: "salon",
      name: "Salón",
      categories: [
        {
          id: "001",
          order: 1,
          hideInMenu: true
        }
      ],
      cameras: [
        {
          id: "salon_01",
          isSummary: true,
          categories: [
            {
              id: "001",
              features: [
                {
                  "id": "001001"
                },
                {
                  "id": "001002"
                }
              ]
            }
          ]
        },
        {
          id: "salon_02",
        },
        {
          id: "salon_03",
        },
      ],
    },
    {
      id: "cocina",
      name: "Cocina",
      categories: [
        {
          id: "001",
          order: 1,
          hideInMenu: true
        }
      ],
      cameras: [
        {
          id: "cocina_01",
        },
        {
          id: "cocina_02",
        },
        {
          id: "cocina_03",
        },
      ],
    },
    {
      id: "servicio-comun",
      name: "Baño Común",
      categories: [
        {
          id: "001",
          order: 1,
          hideInMenu: true
        }
      ],
      cameras: [
        {
          id: "servicio-comun_01",
        },
        {
          id: "servicio-comun_02",
        },
      ],
    },
    {
      id: "suite",
      name: "Suite",
      categories: [
        {
          id: "001",
          order: 1,
          hideInMenu: true
        }
      ],
      cameras: [
        {
          id: "suite_01",
          isSummary: true,
        },
        {
          id: "suite_02",
        },
      ],
    },
    {
      id: "servicio-suite",
      name: "Baño Suite",
      categories: [
        {
          id: "001",
          order: 1,
          hideInMenu: true
        }
      ],
      cameras: [
        {
          id: "servicio-suite_01",
        },
        {
          id: "servicio-suite_02",
        },
      ],
    },
  ],
  categories: [
    {
      id: "009",
      name: "Suelos Vivienda",
      cameras: [
        {
          id: "salon_01",
          roomId: "salon",
        },
        {
          id: "salon_02",
          roomId: "salon",
        },
        {
          id: "salon_03",
          roomId: "salon",
        },
        {
          id: "suite_01",
          roomId: "suite",
        },
        {
          id: "suite_02",
          roomId: "suite",
        },
      ],
      selected_feature: "009001",
      availableIf: null,
      incompatibleWith: null,
      features: [
        {
          id: "009001",
          name: "Suelo laminado HOME SALZBURG de Grupo Porcelanosa",
          description: "",
          thumb: "/thumbnails/_0000s_0000_Suelos_vivienda_Op_1.jpg",
          order: 1,
        },
        {
          id: "009002",
          name: "Suelo laminado RESIDENCE NEVADA de Grupo Porcelanosa",
          description: "",
          thumb: "/thumbnails/_0000s_0001_Suelos_vivienda_Op_2.jpg",
          order: 2,
        },
        {
          id: "009003",
          name: "Suelo laminado RESIDENCE ARIZONA de Grupo Porcelanosa",
          description: "",
          thumb: "/thumbnails/_0000s_0002_Suelos_vivienda_Op_3.jpg",
          order: 3,
        },
        {
          id: "009004",
          name: "Suelo laminado HOME KAPRUN de Grupo Porcelanosa",
          description: "",
          thumb: "/thumbnails/_0000s_0003_Suelos_vivienda_Op_4.jpg",
          order: 4,
        },
      ],
    },
    {
      id: "001",
      name: "Pintura paredes",
      cameras: [
        {
          id: "salon_01",
          roomId: "salon",
        },
        {
          id: "salon_02",
          roomId: "salon",
        },
        {
          id: "salon_03",
          roomId: "salon",
        },
        {
          id: "suite_01",
          roomId: "suite",
        },
        {
          id: "suite_02",
          roomId: "suite",
        }
      ],
      selected_feature: "001001",
      availableIf: null,
      incompatibleWith: null,
      features: [
        {
          id: "001001",
          name: "Pintura general vivienda color 1 - RAL 9001 Crema",
          description: "",
          thumb: "/thumbnails/_0001s_0000_Pintura_paredes_Op_1.jpg",
          order: 1,
        },
        {
          id: "001002",
          name: "Pintura general vivienda color 2 - RAL 9010 Blanco",
          description: "",
          thumb: "/thumbnails/_0001s_0001_Pintura_paredes_Op_2.jpg",
          order: 2,
        },
        {
          id: "001003",
          name: "Pintura general vivienda color 3 - RAL 7035 Gris",
          description: "",
          thumb: "/thumbnails/_0001s_0002_Pintura_paredes_Op_3.jpg",
          order: 3,
        },
      ],
    },
  ],
  sections: [
    {
      id: "001",
      name: "Acabados paredes",
      categories: [
        {
          id: "002",
        },
        {
          id: "004",
        },
        {
          id: "006",
        },
      ],
    },
    {
      id: "002",
      name: "Equipamientos cocina",
      categories: [
        {
          id: "002",
        },
        {
          id: "008",
        },
      ],
    },
    {
      id: "003",
      name: "Equipamientos baños",
      categories: [
        {
          id: "003",
        },
      ],
    },
    {
      id: "004",
      name: "Pavimentos",
      categories: [
        {
          id: "005",
        },
        {
          id: "007",
        },
      ],
    },
  ],
  rules: [
    {
      categoryId: "002",                  // PAVIMENTO COCINA
      featureId: "002004",                // Parquet laminado 1 lama Mod. Easy Line 832 Woodbridge Oak de Tarkett
      condition: {
        condition: "AVAILABLE_IF",        // AVAILABLE IF (SÓLO DISPONIBLE SI)
        affects: [
          {
            categoryId: "005",            // COCINA ABIERTA/CERRADA
            featureId: "005002"           // Cocina abierta al salón
          },
          {
            logic: "OR",
            categoryId: "005",            // COCINA ABIERTA/CERRADA
            featureId: "005003"           // Cocina abierta al salón con barra
          },
          {
            logic: "AND",
            categoryId: "001",            // PAVIMENTOS GENERALES VIVIENDA
            featureId: "001001"           // Parquet laminado 1 lama Mod. Easy Line 832 Woodbridge Oak de Tarkett
          }
        ]
      }
    },
    {
      categoryId: "002",                  // PAVIMENTO COCINA
      featureId: "002005",                // Parquet laminado 1 lama Mod. Easy Line 832 Woodbridge Oak de Tarkett
      rule: {
        condition: "AVAILABLE_IF",        // AVAILABLE IF (SÓLO DISPONIBLE SI)
        affects: [
          {
            categoryId: "005",            // COCINA ABIERTA/CERRADA
            featureId: "005002"           // Cocina abierta al salón
          },
          {
            logic: "OR",
            categoryId: "005",            // COCINA ABIERTA/CERRADA
            featureId: "005003"           // Cocina abierta al salón con barra
          },
          {
            logic: "AND",
            categoryId: "001",            // PAVIMENTOS GENERALES VIVIENDA
            featureId: "001002"           // Parquet laminado 1 lama Mod. Easy Line 832 Woodbridge Oak de Tarkett
          }
        ]
      }
    },
    {
      categoryId: "002",                  // PAVIMENTO COCINA
      featureId: "002006",                // Parquet laminado 1 lama Mod. Easy Line 832 Woodbridge Oak de Tarkett
      rule: {
        condition: "AVAILABLE_IF",        // AVAILABLE IF (SÓLO DISPONIBLE SI)
        affects: [
          {
            categoryId: "005",            // COCINA ABIERTA/CERRADA
            featureId: "005002"           // Cocina abierta al salón
          },
          {
            logic: "OR",
            categoryId: "005",            // COCINA ABIERTA/CERRADA
            featureId: "005003"           // Cocina abierta al salón con barra
          },
          {
            logic: "AND",
            categoryId: "001",            // PAVIMENTOS GENERALES VIVIENDA
            featureId: "001003"           // Parquet laminado 1 lama Mod. Easy Line 832 Woodbridge Oak de Tarkett
          }
        ]
      }
    },
    {
      categoryId: "002",                  // PAVIMENTO COCINA
      featureId: "002007",                // Parquet laminado 1 lama Mod. Easy Line 832 Woodbridge Oak de Tarkett
      rule: {
        condition: "AVAILABLE_IF",        // AVAILABLE IF (SÓLO DISPONIBLE SI)
        affects: [
          {
            categoryId: "005",            // COCINA ABIERTA/CERRADA
            featureId: "005002"           // Cocina abierta al salón
          },
          {
            logic: "OR",
            categoryId: "005",            // COCINA ABIERTA/CERRADA
            featureId: "005003"           // Cocina abierta al salón con barra
          },
          {
            logic: "AND",
            categoryId: "001",            // PAVIMENTOS GENERALES VIVIENDA
            featureId: "001004"           // Parquet laminado 1 lama Mod. Easy Line 832 Woodbridge Oak de Tarkett
          }
        ]
      }
    },
    {
      categoryId: "005",                  // COCINA ABIERTA/CERRADA
      featureId: "005001",                // Cocina semi-cerrada
      rule: {
        condition: "AVAILABLE_IF",        // AVAILABLE IF (SÓLO DISPONIBLE SI)
        affects: [
          {
            categoryId: "002",            // PAV COCINA
            featureId: "002001"           // 1
          },
          {
            logic: "OR",
            categoryId: "002",            // PAV COCINA
            featureId: "002002"           // 2
          },
          {
            logic: "OR",
            categoryId: "002",            // PAV COCINA
            featureId: "002003"           // 3
          }
        ]
      }
    },
    {
      categoryId: "001",                  // Pav Generales
      featureId: "001001",                // 1
      rule: {
        condition: "AVAILABLE_IF",        // AVAILABLE IF (SÓLO DISPONIBLE SI)
        affects: [
          {
            categoryId: "002",            // PAV COCINA
            featureId: "002004"           // 4
          },
          {
            logic: "OR",
            categoryId: "002",            // PAV COCINA
            featureId: "002001"           // 1
          },
          {
            logic: "OR",
            categoryId: "002",            // PAV COCINA
            featureId: "002002"           // 2
          },
          {
            logic: "OR",
            categoryId: "002",            // PAV COCINA
            featureId: "002003"           // 3
          }
        ]
      }
    },
    {
      categoryId: "001",                  // Pav Generales
      featureId: "001002",                // 1
      rule: {
        condition: "AVAILABLE_IF",        // AVAILABLE IF (SÓLO DISPONIBLE SI)
        affects: [
          {
            categoryId: "002",            // PAV COCINA
            featureId: "002005"           // 5
          },
          {
            logic: "OR",
            categoryId: "002",            // PAV COCINA
            featureId: "002001"           // 1
          },
          {
            logic: "OR",
            categoryId: "002",            // PAV COCINA
            featureId: "002002"           // 2
          },
          {
            logic: "OR",
            categoryId: "002",            // PAV COCINA
            featureId: "002003"           // 3
          }
        ]
      }
    },
    {
      categoryId: "001",                  // Pav Generales
      featureId: "001003",                // 1
      rule: {
        condition: "AVAILABLE_IF",        // AVAILABLE IF (SÓLO DISPONIBLE SI)
        affects: [
          {
            categoryId: "002",            // PAV COCINA
            featureId: "002006"           // 6
          },
          {
            logic: "OR",
            categoryId: "002",            // PAV COCINA
            featureId: "002001"           // 1
          },
          {
            logic: "OR",
            categoryId: "002",            // PAV COCINA
            featureId: "002002"           // 2
          },
          {
            logic: "OR",
            categoryId: "002",            // PAV COCINA
            featureId: "002003"           // 3
          }
        ]
      }
    },
    {
      categoryId: "001",                  // Pav Generales
      featureId: "001004",                // 1
      rule: {
        condition: "AVAILABLE_IF",        // AVAILABLE IF (SÓLO DISPONIBLE SI)
        affects: [
          {
            categoryId: "002",            // PAV COCINA
            featureId: "002007"           // 6
          },
          {
            logic: "OR",
            categoryId: "002",            // PAV COCINA
            featureId: "002001"           // 1
          },
          {
            logic: "OR",
            categoryId: "002",            // PAV COCINA
            featureId: "002002"           // 2
          },
          {
            logic: "OR",
            categoryId: "002",            // PAV COCINA
            featureId: "002003"           // 3
          }
        ]
      }
    }
  ],
  improvementRules: [
    {
      originId: "002",
      destinationId: "003",
      ruleType: "AVAILABLE_IF"
    }
  ],
  prices: [
    {
      categoryId: "002",
      featureId: "002004",
      hasPrice: true,
      price: 69.95,
    }
  ],
  summaryCameras: [
    {
      id: "salon_01",
    },
    {
      id: "cocina_01",
    },
  ],
  printingCameras: [
    {
      id: "servicio-comun_01",
    },
    {
      id: "salon_01",
    },
    {
      id: "cocina_01",
    },
    {
      id: "servicio-suite_01",
    },
    {
      id: "suite_01",
    },
  ]
};

export default BizionarDemoMock;
